import styled, { css } from 'styled-components';
import { Radio, getBorderedRadioStyles } from 'ui/radio';
import {
  baseColors,
  body2,
  caption,
  fontWeights,
  spacing,
  subtleShadow,
  textColors,
} from 'ui/theme';
import { Tooltip } from 'ui/tooltip';
import { pxToRem } from 'utils/convert';

export const Wrapper = styled.div`
  align-items: flex-start;
  display: inline-flex;
  flex-direction: column;
`;

export const GroupLabel = styled.span`
  display: block;
  margin-bottom: ${spacing.half};
`;

const getRowBordering = (isDisabled = false, isChecked = false) => css`
  border: ${spacing.single} solid ${baseColors.grey15};
  border-radius: ${spacing.quarter};
  padding: ${spacing.base} ${spacing.threeQuarter};
  width: 100%;
  box-shadow: ${subtleShadow.boxShadow};
  ${getBorderedRadioStyles(isDisabled, isChecked)}
`;

export const StyledTooltip = styled(Tooltip)`
  width: 100%;
`;

export const Row = styled.div<{
  isBordered?: boolean;
  isChecked?: boolean;
  isDisabled?: boolean;
  isReadOnly?: boolean;
}>`
  display: inline-flex;
  justify-content: space-between;
  margin-bottom: ${spacing.half};
  gap: ${spacing.half};

  ${({ isDisabled, isReadOnly }) =>
    isDisabled &&
    css`
      // allow links to be clickable in read-only state
      *${isReadOnly ? ':not(a)' : ''} {
        cursor: not-allowed;
        color: ${textColors.textDisabled};
      }
    `}
  ${({ isDisabled, isChecked, isBordered }) =>
    isBordered ? getRowBordering(isDisabled, isChecked) : ''}
`;

const AlignCenter = `align-items: center;`;

export const LeftDiv = styled.div<{ hasSupplementalText: boolean }>`
  display: flex;
  justify-content: flex-start;
  gap: ${spacing.half};

  ${({ hasSupplementalText }) => (!hasSupplementalText ? AlignCenter : ``)};
`;

const RadioOffset = `
margin-top: ${spacing.quarter};
`;

export const RadioButton = styled(Radio)<{ hasSupplementalText: boolean }>`
  ${({ hasSupplementalText }) => (!hasSupplementalText ? RadioOffset : ``)};
`;

export const TextWrapper = styled.div`
  cursor: default;
  ${body2};
`;

export const Label = styled.span`
  border: solid 1px ${baseColors.grey15};
  border-radius: ${spacing.quarter};
  margin-left: ${spacing.base};
  padding: ${spacing.eighth} ${spacing.quarter};
`;

export const HelpToggleTipWrapper = styled.div`
  margin: ${pxToRem(3)} 0 0 ${spacing.half};
  ${css`
    * {
      cursor: pointer;
    }
  `}
`;

export const TopText = styled.div<{ hasSupplementalText: boolean; isRegularWeight?: boolean }>`
  align-items: center;
  display: flex;
  font-weight: ${(props) => (props.isRegularWeight ? fontWeights.regular : fontWeights.medium)};
  color: ${textColors.textPrimary};

  ${({ hasSupplementalText, isRegularWeight }) =>
    hasSupplementalText && !isRegularWeight ? `margin-bottom: ${spacing.quarter}` : ``};

  &[label='true'] {
    margin-bottom: ${spacing.quarter};
  }
  &:hover {
    cursor: pointer;
  }
`;

export const Description = styled.p`
  ${caption}
  color: ${textColors.textSecondary};
  font-weight: ${fontWeights.regular};
  margin: 0;
`;
